<div class="container-fluid">
  <div class="row text-start mt-3">
    <h1 class="col-12 col-sm-6">
      {{ 'privacy.privacy_ecoach_title' | translate }}
    </h1>
    <a
      *ngIf="(isAuthenticated$ | async) === false"
      mat-button
      class="col-12 col-sm-6 mb-2"
      color="primary"
      (click)="redirectToLogin()"
    >
      <fa-icon [icon]="faArrowLeft"></fa-icon> {{ 'privacy.back_to_login' | translate }}
    </a>
    <hr />
  </div>

  <div *ngIf="language === 'de'">
    <p>
      Sehr geehrte Nutzer:innen der Plattform eSano,<br />
      <br />
      der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Deshalb informieren wir Sie an dieser Stelle, zu welchem Zweck wir Ihre Daten
      erheben, speichern oder weiterleiten. Sollten Sie die Plattform im Rahmen einer Studie nutzen, können weitere datenschutzrelevante
      Anforderungen in den dazugehörigen Teilnahmeinformationen bzw. Einwilligungserklärungen Geltung finden. Diesen Informationen können Sie
      ggf. auch entnehmen, welche Rechte Ihnen bezüglich Ihrer personenbezogenen Daten zusteht.
    </p>

    <h3>1. Verantwortlicher für die Datenverarbeitung</h3>
    <p>
      Verantwortlicher für die Datenverarbeitung ist genannt gem. Art. 4 Abs. 7<br />
      Datenschutzgrundverordnung (DSGVO) die<br />
      <br />
      Universität Ulm <br />
      89069 Ulm<br />
      Telefon +49 (0)731/50-10<br />
      Telefax +49 (0)731/50-22038<br />
      <br />
      Die Universität Ulm ist eine Körperschaft des öffentlichen Rechts, die durch den Präsidenten Prof. Dr.-Ing. Michael Weber
      <a href="mailto:praesident@uni-ulm.de">praesident@uni-ulm.de</a> oder durch den Kanzler Dieter Kaufmann
      <a href="mailto:kanzler@uni-ulm.de">kanzler@uni-ulm.de</a> vertreten wird. Bei Fragen rund um den Datenschutz wenden Sie sich bitte an
      <a href="mailto:dsb@uni-ulm.de">dsb@uni-ulm.de</a> oder senden einen Brief mit dem Zusatz "Datenschutzbeauftragte" an die o. g.
      Adresse.<br />
      <br />
      Weitere spezifische Informationen bezüglich der jeweiligen Studie, an der Sie ggf. teilnehmen, finden Sie in den zugehörigen
      Teilnahmeinformationen bzw. Einwilligungserklärungen.
    </p>

    <h3>2. Datenkategorien, Zweck und Rechtsgrundlage der Datenverarbeitung</h3>
    <p>
      Das Online-Interventionsprogramm wird auf der passwortgeschützten Online-Plattform eSano der Universität Ulm angeboten. Die Plattform
      eSano wird vom Institut für Datenbanken und Informationssystem (DBIS) und der Abteilung für Klinische Psychologie und Psychotherapie der
      Universität Ulm verwaltet. Die Plattform besteht aus einem Content Management System zur Erstellung von Inhalten, einer
      Nutzer:innen-Plattform und einer Therapeut:innen-Plattform (eCoach Plattform). Alle Daten, die über die Plattform erhoben werden,
      werden auf den in Deutschland verorteten Servern der Hetzner Online GmbH verschlüsselt gespeichert. Es werden die folgenden personenbezogenen Daten
      von Ihnen verarbeitet:
    </p>
    <ul>
      <li>E-Mail-Adresse</li>
      <li>Eingaben in Interventionen und Tagebüchern</li>
      <li>Konversationen mit betreuten Nutzer:innen und anderen eCoaches</li>
      <li>
        Nutzungsdaten der Plattform in Hinblick auf das allgemeine Nutzungsverhalten (z.B. Zeitpunkt der Logins) sowie auf
        eCoach-Nutzer:innen-Interaktion
      </li>
    </ul>
    <p>
      Wir verarbeiten personenbezogene Daten unserer Nutzer:innen grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen
      Webseite sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten unserer Nutzer:innen erfolgt
      regelmäßig nur nach freiwilliger, informierter Einwilligung der Nutzer:innen. Sollten Sie diese Plattform im Rahmen einer
      Studie nutzen, können Sie weitere Details den jeweils zugehörigen Teilnahmeinformationen bzw. der Einwilligungserklärung entnehmen.
      Rechtsgrundlage für die Verarbeitung ist in diesem Fall Ihre Einwilligung zur Teilnahme an der jeweiligen Studie gem. Art. 6 Abs. 1 lit.
      a EU-DSGVO.
    </p>

    <p>
      Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung
      personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.
    </p>

    <p>
      Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns
      dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Einige Cookies sind “Session-Cookies.” Solche Cookies werden
      nach Ende Ihrer Browser-Sitzung von selbst gelöscht. Hingegen bleiben andere Cookies auf Ihrem Endgerät bestehen, bis Sie diese selbst
      löschen. Solche Cookies helfen uns, Sie bei Rückkehr auf unserer Website wiederzuerkennen. Mit einem modernen Webbrowser können Sie das
      Setzen von Cookies überwachen, einschränken oder unterbinden. Viele Webbrowser lassen sich so konfigurieren, dass Cookies mit dem
      Schließen des Programms von selbst gelöscht werden. Die Deaktivierung von Cookies kann eine eingeschränkte Funktionalität unserer
      Website zur Folge haben. Das Setzen von Cookies, die zur Ausübung elektronischer Kommunikationsvorgänge oder der Bereitstellung
      bestimmter, von Ihnen erwünschter Funktionen notwendig sind, erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
      Als Betreiber dieser Website haben wir ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und
      reibungslosen Bereitstellung unserer Dienste. Sofern die Setzung anderer Cookies (z.B. für Analyse-Funktionen) erfolgt, werden diese in
      dieser Datenschutzerklärung separat behandelt.
    </p>

    <p>
      In Server-Log-Dateien erheben und speichern wir automatisch Informationen, die Ihr Browser automatisch an uns übermittelt und
      die erforderlich sind, um die ordnungsmäßen Funktionalität der Plattform sowie deren Stabilität und Sicherheit zu gewährleisten
      (Rechtsgrundlage ist dabei Art. 6 Abs. 1 S. 1 lit. f DSGVO):
    </p>

    <ul>
      <li>Besuchte Seite auf unserer Domain</li>
      <li>Browsertyp und Browserversion</li>
      <li>Verwendetes Betriebssystem</li>
      <li>Referrer URL</li>
      <li>Hostname des zugreifenden Rechners</li>
      <li>Datum und Uhrzeit der Serveranfrage</li>
      <li>IP-Adresse</li>
    </ul>

    <h3>3. TLS-Verschlüsselung</h3>
    <p>
      Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als Seitenbetreiber senden, nutzt unsere
      Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie über diese Plattform übermitteln, für Dritte nicht mitlesbar. Sie
      erkennen eine verschlüsselte Verbindung an der „https://“ Adresszeile Ihres Browsers und am Schloss- Symbol in der Browserzeile.
    </p>

    <h3>4. Speicherung Ihrer Daten</h3>
    <p>
      Sofern einer Löschung keine sonstigen berechtigten Interessen des für die Verarbeitung Verantwortlichen entgegenstehen, erfolgt die
      Löschung bei Teilnahme an einer Studie oder an einem Forschungsprojekt entsprechend der dortigen Speicherdauer. Sollten Sie die
      Plattform im Rahmen einer Studie nutzen, finden Sie weitere spezifische Informationen in den zugehörigen Teilnahmeinformationen bzw. der
      Einwilligungserklärung. Bitte informieren Sie sich diesbezüglich über die Löschfrist im Rahmen der entsprechenden Studie oder des
      Forschungsprojekts.
    </p>

    <p>
      Ihre Daten werden so lange gespeichert, wie sie für die ordnungsgemäße Funktionalität der Plattform benötigt werden, spätestens bis zur
      Löschung Ihres Accounts. Wird Ihr Account gelöscht, werden Ihre personenbezogenen Daten gelöscht oder der Personenbezug entfernt.
    </p>

    <h3>5. Empfänger Ihrer Daten</h3>
    <p>
      Im Rahmen der Nutzung der Online-Plattform werden Ihre Daten, sofern in den Teilnahmeinformationen bzw. der Einwilligungserklärung der
      jeweiligen Studie, an der Sie ggf. teilnehmen, nicht anders benannt, von der Abteilung für Klinische Psychologie und Psychotherapie der
      Universität Ulm zu wissenschaftlichen Zwecken verwendet.
    </p>

    <h3>6. Datenverarbeitung durch einen Dritten</h3>
    <p>
      Für das Hosting der Online-Plattform nutzen wir Server verwaltet von der Firma<br />
      <br />
      ADMIN INTELLIGENCE GmbH<br />
      Sedanstraße 124<br />
      89077 Ulm<br />
      <br />

      ADMIN INTELLIGENCE GmbH nutzt für das Hosting wiederum Server der Firma<br />
      <br />
      Hetzner Online GmbH<br />
      Industriestr. 25<br />
      91710 Gunzenhausen<br />
      <br />

      Ihre eingegebenen Daten werden für uns bei den Firmen ADMIN INTELLIGENCE GmbH und Hetzner Online GmbH verarbeitet. Alle notwendigen
      technischen und organisatorischen Sicherheitsmaßnahmen, um Ihre personenbezogenen Daten vor Verlust und Missbrauch zu schützen, werden
      von uns und in unserem Auftrag von den Firmen ADMIN INTELLIGENCE GmbH und Hetzner Online GmbH getroffen.
    </p>

    <h3>7. Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
    <p>
      Die Einwilligung zur Datenverarbeitung ist freiwillig. Sie haben das Recht, Ihre Einwilligung jederzeit und ohne Angaben von Gründen zu
      widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit, der aufgrund der Einwilligung bis zum Widerruf erfolgten
      Verarbeitung nicht berührt. Sollten Sie die Plattform im Rahmen einer Studie nutzen, richten Sie Ihren Widerruf als formlose Mitteilung
      an die in Teilnahmeinformationen bzw. der Einwilligungserklärung Ihrer jeweiligen Studie genannte Adresse.
    </p>

    <h3>8. Ihre Rechte als Betroffener</h3>

    <p>Zum Schutz Ihrer personenbezogenen Daten stehen Ihnen folgende Rechte zu:</p>

    <ul>
      <li>Ihre Einwilligung widerrufen (Art. 7 Abs. 3 DSGVO),</li>
      <li>Auskunft über die Sie betreffenden personenbezogenen Daten zu erhalten (Art. 15 DSGVO),</li>
      <li>unrichtige Daten berichtigen zu lassen (Art. 16 DSGVO),</li>
      <li>
        unter bestimmten Voraussetzungen die Löschung oder Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen (Art. 17,
        18 DSGVO),
      </li>
      <li>Widerspruch gegen die Verarbeitung Ihrer Daten einzulegen (Art. 21 DSGVO),</li>
      <li>Ihre Daten zu erhalten und an andere von Ihnen bestimmte Stellen übertragen (Art. 20 DSGVO),</li>
      <li>eine Beschwerde einreichen (Art. 77 DSGVO)</li>
    </ul>

    <p>
      Sie haben das Recht, sich an die zuständige Aufsichtsbehörde für den Datenschutz zu wenden, wenn Sie der Ansicht sind, dass die
      Verarbeitung Ihrer personenbezogenen Daten nicht rechtmäßig erfolgt. Die für uns zuständige Aufsichtsbehörde ist der Landesbeauftragte
      für Datenschutz und Informationsfreiheit Baden-Württemberg.
    </p>

    <p>
      Weitere Informationen und Ansprechpartner:innen hierzu finden Sie in den Teilnahmeinformationen bzw. der Einwilligungserklärung der
      jeweiligen Studie, an der Sie ggf. teilnehmen.
    </p>
  </div>

  <div *ngIf="language !== 'de'">
    <p>
      Dear users of the eSano Platform,<br /><br />
      the protection of your personal data is important to us.
      Therefore, we would like to inform you at this point for what purpose we collect, store or forward your data.
      If you use the platform as part of a study, further data protection requirements may apply as specified in the associated participation
      information or informed consent forms. This information may also tell you what rights you have with regard to your personal data.
    </p>

    <h3>1. Controller responsible for data processing</h3>
    <p>
      Legally accountable institution as per Art. 4 para. 7 GDPR (General Data Protection Regulation) is
    </p>

    Ulm University<br />
    89069 Ulm<br />
    Germany<br />
    Phone +49 (0)731/50-10<br />
    Fax +49 (0)731/50-22038<br /><br />

    <p>
      Ulm University is a public body and is represented by its President, Prof. Dr.-Ing. Michael Weber
      <a href="mailto:praesident@uni-ulm.de">praesident&#64;uni-ulm.de</a> or its Chief Financial Officer, Dieter Kaufmann
      <a href="mailto:kanzler@uni-ulm.de">kanzler&#64;uni-ulm.de</a>. If you have any questions about data protection,
      please contact <a href="mailto:dsb@uni-ulm.de">dsb&#64;uni-ulm.de</a> or send a letter with the addition "Data Protection Officer" to the above address.
    </p>
    <p>
      Further specific information regarding the respective study in which you may be participating can be found in the associated participation
      information or informed consent forms.
    </p>

    <h3>2. Data categories, purpose and legal basis of data processing</h3>
    <p>
      The online intervention program is offered on the password-protected online platform eSano of Ulm University.
      The eSano Platform is managed by the Institute for Databases and Information System (DBIS)
      and the Department of Clinical Psychology and Psychotherapy at Ulm University.
      The platform consists of a content management system for the creation of content, a user platform, and a therapist platform (eCoach Platform).
      All data that is collected via the platform is stored in encrypted form on the servers of Hetzner Online GmbH located in Germany.
      The following personal data is processed by you:
    </p>
    <ul>
      <li>E-mail address</li>
      <li>Entries in interventions and diaries</li>
      <li>Conversations with supervised users and other eCoaches</li>
      <li>Usage data of the platform with regard to general usage behavior (e.g., time of logins) and the eCoach user interaction</li>
    </ul>
    <p>
      We generally only process our users' personal data to the extent necessary to provide a functional website and our content and services.
      The processing of personal data of our users takes place regularly only with the voluntary, informed consent of the users.
      If you use this platform as part of a study, you can find further details in the relevant participation information or the informed consent form.
      In this case, the legal basis for the processing is your consent to participate in the respective study in accordance with Art. 6 para. 1 lit. a EU GDPR.
    </p>

    <p>
      In the event that vital interests of the data subject or another natural person require the processing of personal data,
      Art. 6 para. 1 lit. d GDPR serves as the legal basis.
    </p>

    <p>
      Our website uses cookies. These are small text files that your web browser stores on your end device.
      Cookies help us to make our website more user-friendly, effective and secure. Some cookies are "session cookies".
      Such cookies are deleted automatically at the end of your browser session.
      Other cookies, on the other hand, remain on your device until you delete them yourself.
      Such cookies help us to recognize you when you return to our website.
      With a modern web browser, you can monitor, restrict or prevent the setting of cookies.
      Many web browsers can be configured so that cookies are deleted automatically when the program is closed.
      Deactivating cookies may result in limited functionality of our website.
      The setting of cookies, which are necessary for the performance of electronic communication processes or the provision
      of certain functions desired by you, takes place on the basis of Art. 6 para. 1 lit. f GDPR. As the operator of this website,
      we have a legitimate interest in the storage of cookies for the technically error-free and smooth provision of our services.
      If other cookies are set (e.g. for analysis functions), these are treated separately in this Privacy Policy.
    </p>

    <p>
      In server log files, we automatically collect and store information that your browser automatically transmits
      to us and that is necessary to ensure the proper functionality of the platform as well as its stability and security
      (legal basis is Art. 6 para. 1 sentence 1 lit. f GDPR):
    </p>

    <ul>
      <li>Visited page on our domain</li>
      <li>Browser type and browser version</li>
      <li>Operating system used</li>
      <li>Referrer URL</li>
      <li>Host name of the accessing computer</li>
      <li>Date and time of the server request</li>
      <li>IP address</li>
    </ul>

    <h3>3. TLS encryption</h3>
    <p>
      For security reasons and to protect the transmission of confidential content that you send to us as the site operator,
      our website uses SSL or TLS encryption. This means that data that you transmit via this platform cannot be read by third parties.
      You can recognize an encrypted connection by the "https://" address line of your browser and the lock symbol in the browser line.
    </p>

    <h3>4. Storage of your data</h3>
    <p>
      Provided that there are no other legitimate interests of the controller that prevent deletion,
      deletion will take place in the event of participation in a study or research project in accordance with the storage period specified therein.
      If you use the platform as part of a study, you will find further specific information in the associated participation
      information or the informed consent form. In this regard, please inform yourself about the deletion period in the context of the
      relevant study or research project.
    </p>

    <p>
      Your data will be stored for as long as it is required for the proper functionality of the platform, at the latest until your account is deleted.
      If your account is deleted, your personal data will be deleted or the personal reference will be removed.
    </p>

    <h3>5. Recipients of your data</h3>
    <p>
      When using the online platform, your data will be used for scientific purposes by the Department of Clinical Psychology
      and Psychotherapy at Ulm University, unless otherwise stated in the participation information or the informed consent of the respective study
      in which you may be participating.
    </p>

    <h3>6. Data processing by a third party</h3>
    <p>
      For the hosting of the online platform we use servers managed by the company<br />
      <br />
      ADMIN INTELLIGENCE GmbH<br />
      Sedanstraße 124<br />
      89077 Ulm<br />
      Germany<br />
      <br />

      ADMIN INTELLIGENCE GmbH in turn uses servers from the provider<br /><br />

      Hetzner Online GmbH<br />
      Industriestr. 25<br />
      91710 Gunzenhausen<br />
      Germany<br /><br />

      The data you enter will be processed for us by the companies ADMIN INTELLIGENCE GmbH and Hetzner Online GmbH.
      All necessary technical and organizational security measures to protect your personal data from loss and misuse are taken
      by us and on our behalf by the companies ADMIN INTELLIGENCE GmbH and Hetzner Online GmbH.
    </p>

    <h3>7. Withdrawal of your consent to data processing</h3>
    <p>
      Consent to data processing is voluntary. You have the right to withdraw your consent at any time and without giving reasons.
      The withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.
      If you are using the platform as part of a study, please send your withdrawal as an informal message to the address stated in the participation
      information or the informed consent for your respective study.
    </p>

    <h3>8. Your rights as a data subject</h3>

    <p>You have the following rights to protect your personal data:</p>

    <ul>
      <li>To withdraw your consent (Art. 7 (3) GDPR),</li>
      <li>to obtain information about the personal data concerning you (Art. 15 GDPR),</li>
      <li>to have incorrect data corrected (Art. 16 GDPR),</li>
      <li>under certain conditions, to request the erasure or restriction of the processing of your personal data (Art. 17, 18 GDPR),</li>
      <li>to object to the processing of your data (Art. 21 GDPR),</li>
      <li>to receive your data and transfer it to another controller designated by you (Art. 20 GDPR),</li>
      <li>to lodge a complaint (Art. 77 GDPR).</li>
    </ul>

    <p>
      You have the right to contact the responsible supervisory authority for data protection if you are of the opinion that the processing
      of your personal data is not lawful. The supervisory authority responsible for us is the Landesbeauftragte
      für Datenschutz und Informationsfreiheit Baden-Württemberg (Germany).
    </p>

    <p>
      Further information and contact persons can be found in the participation information or the informed consent of the respective
      study in which you may be participating.
    </p>
  </div>
</div>
